import PageManipulationOverlayButtonContainer from './PageManipulationOverlayButtonContainer';

export default PageManipulationOverlayButtonContainer;